module.exports = __webpack_public_path__ + "static/media/Reverse_Primer.729cdf5a.svg";